import React, { useMemo } from 'react';
import { Popover, Spin, Space } from 'antd';
import Dongdong from '@/components/dongdong';
import { Timeline } from 'antd';
import { enhancedFormateTimeStamp } from '@/common/utils/format-time';
import { TYPE_ARR } from './constants';
import './index.less';

const CheckFlow = ({ flowArr = [], fieldNames = null, ...props }) => {
  let flowArrDealed = [];
  flowArrDealed = useMemo(() => {
    if (!fieldNames) return flowArr;
    let arr = [];
    flowArr.map((item) => {
      arr.push({
        title: fieldNames?.title ? item[fieldNames.title] : item.title,
        erp: fieldNames?.erp ? item[fieldNames.erp] : item.erp,
        time: fieldNames?.time ? item[fieldNames.time] : item.time,
        content: fieldNames?.content ? item[fieldNames.content] : item.content,
        realName: fieldNames?.realName ? item[fieldNames.realName] : item.realName,
        color: item.color,
      });
    });

    return arr;
  }, [fieldNames, flowArr]);

  const Item = ({ item }) => {
    const { erp, title, time, content, realName } = item;
    return (
      <>
        <div className="TY_check-flow-item__title">{title}</div>
        {content && <div className="TY_check-flow-item__content">{content}</div>}
        {!erp && !time ? null : (
          <Space className="TY_check-flow-item__checker" size={15}>
            {erp && <Dongdong name={realName} erp={erp} size="small" />}
            {time && (
              <div className="TY_check-flow-item__checker-time">{enhancedFormateTimeStamp(time, 'MM-DD hh:mm')}</div>
            )}
          </Space>
        )}
      </>
    );
  };

  return (
    <Popover
      {...props}
      mouseEnterDelay={0.2}
      content={
        <div className="TY_check-flow-wrap">
          {flowArrDealed.length <= 0 ? (
            <Spin />
          ) : (
            <Timeline>
              {flowArrDealed.map((item, index) => {
                const { color = 'gray' } = item;
                return (
                  <Timeline.Item
                    className={color === 'green' ? 'TY_check-flow-item success' : 'TY_check-flow-item'}
                    color={color}
                    key={index}
                    dot={TYPE_ARR.get(color)}
                  >
                    <Item item={item} color={color} />
                  </Timeline.Item>
                );
              })}
            </Timeline>
          )}
        </div>
      }
    >
      {props.children}
    </Popover>
  );
};

export default React.memo(CheckFlow);
